import { PhoneOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { CALL_STATES, SDK_STATUSES, useInternalDialer } from "../internalDialerContext";

function ClickToCallButton({ phoneNumber, debtorId, phoneId = undefined, e164Number = undefined }) {
  const { isEnabled, callState, sdkStatus, callPhone, showWidget, connect } = useInternalDialer();

  if (!isEnabled || !phoneNumber) {
    return null;
  }

  const isInitiating = callState === CALL_STATES.CALLING;
  const isInCall = callState === CALL_STATES.ACTIVE || callState === CALL_STATES.INCOMING;

  const handleClick = async (e) => {
    e.stopPropagation();

    if (sdkStatus === SDK_STATUSES.DISCONNECTED) {
      await connect();
    }

    showWidget();

    try {
      await callPhone({
        phoneNumber,
        debtorId,
        debtorContactPhoneId: phoneId,
        e164Number,
      });
    } catch (err) {
      console.error("Call initiation error:", err);
    }
  };

  return (
    <Tooltip title={`Call ${phoneNumber}`}>
      <Button
        type="link"
        icon={<PhoneOutlined />}
        onClick={handleClick}
        loading={isInitiating}
        disabled={isInCall}
        aria-label={`Call ${phoneNumber}`}
      />
    </Tooltip>
  );
}

export default ClickToCallButton;
